import { useToast } from "@/components/ui/use-toast";
import { Module } from "@/constants";
import { useMutationWithErrorHandling } from "@/hooks/useMutationWithErrorHandling";
import { PayrollsService } from "@/services/payrolls";
import { UpdatePayrollDepartmentBasedInspection } from "@/types/payrollDepartmentBasedInspection";
import { UpdatePayrollRoleBasedInspection } from "@/types/payrollRoleBasedInspection";
import { useQueryClient } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { usePayrollParams } from "./usePayrollParams";
import { ProjectDependsOn } from "@/schemas/commonFields";

export const useUpdatePayrollInspectionsMutation = (
  projectDependsOn: ProjectDependsOn | undefined,
) => {
  const { t } = useTranslation();
  const { toast } = useToast();
  const { payrollId } = usePayrollParams();
  const queryClient = useQueryClient();

  return useMutationWithErrorHandling({
    errorTitle: t("payrolls.errors.update"),
    mutationFn: (
      entries: (
        | UpdatePayrollDepartmentBasedInspection
        | UpdatePayrollRoleBasedInspection
      )[],
    ) => {
      if (projectDependsOn === undefined) {
        return Promise.resolve();
      }
      return PayrollsService.updatePayrollInspections(
        entries,
        projectDependsOn,
      );
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [Module.Payrolls, payrollId],
      });
      toast({
        title: t("payrolls.success.update"),
      });
    },
  });
};
